import { render, staticRenderFns } from "./TagDeleteModal.vue?vue&type=template&id=8156edb2&scoped=true&"
import script from "./TagDeleteModal.vue?vue&type=script&lang=js&"
export * from "./TagDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./TagDeleteModal.vue?vue&type=style&index=0&id=8156edb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8156edb2",
  null
  
)

export default component.exports